import { useContext, useState } from "react";
import { EditorContext } from "../EditorCommon/EditorContext";


export function CabinetDepthSetter(props: React.HTMLProps<HTMLSelectElement>) {

    const ec = useContext(EditorContext);

    const [depthStr, setDepthStr] = useState(ec.cabinet.depth?.toString() ?? "");
    function setDepth(evt: React.ChangeEvent<HTMLSelectElement>) {
        const _depthStr = evt.target.value;
        const depth = parseInt(_depthStr);
        if (!Number.isNaN(depth)) {
            setDepthStr(_depthStr);
            ec.cabinetService.setCabinetDepth(depth);
        }
    }
    const depths = ec.cabinetService.getProductLine()?.gableProducts.map((gp) => (
        <option value={gp.size.z} key={gp.size.z}>
            {gp.size.z}
        </option>
    ));


    return (
        <select
            {...props}
            value={depthStr}
            onChange={setDepth}
        >
            {depths}
        </select>
    );
}
